export const name = "COTH";
export const summary = `Computes the hyperbolic cotangent of \`X\`.`;
export const reference = `
## COTH

Computes the hyperbolic cotangent of \`X\`.

\`\`\`
COTH(X)
\`\`\`

### Description

Computes the hyperbolic cotangent for the angle of \`X\`, where \`X\` is specified in radians. \`X\` can be any data type that coerces to \`FLOAT64\`. Supports the \`SAFE.\` prefix.

| X | COTH(X) |
| --- | --- |
| \`+inf\` | \`1\` |
| \`-inf\` | \`-1\` |
| \`NaN\` | \`NaN\` |
| \`0\` | \`Error\` |
| \`NULL\` | \`NULL\` |


### Return Data Type

\`FLOAT64\`


### Example



\`\`\`
SELECT COTH(1) AS a, SAFE.COTH(0) AS b;

/*----------------+------*
 | a | b |
 +----------------+------+
 | 1.313035285499 | NULL |
 *----------------+------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
